/**
 * StarRating Component
 * Reusable star rating component for both input and display
 */

import React, { useState } from 'react';
import './Review.css';

const StarRating = ({
  rating = 0,
  onRatingChange,
  size = 'medium',
  readonly = false,
  showLabel = false
}) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = (star) => {
    if (!readonly) {
      setHoverRating(star);
    }
  };

  const handleMouseLeave = () => {
    if (!readonly) {
      setHoverRating(0);
    }
  };

  const handleClick = (star) => {
    if (!readonly && onRatingChange) {
      onRatingChange(star);
    }
  };

  const getRatingLabel = (value) => {
    const labels = {
      1: 'Poor',
      2: 'Fair',
      3: 'Good',
      4: 'Very Good',
      5: 'Excellent'
    };
    return labels[value] || '';
  };

  const displayRating = hoverRating || rating;

  return (
    <div className={`star-rating star-rating-${size} ${readonly ? 'readonly' : 'interactive'}`}>
      <div className="star-rating-stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`star ${star <= displayRating ? 'filled' : 'empty'}`}
            onMouseEnter={() => handleMouseEnter(star)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(star)}
            role={readonly ? 'img' : 'button'}
            aria-label={`${star} star${star > 1 ? 's' : ''}`}
            tabIndex={readonly ? -1 : 0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleClick(star);
              }
            }}
          >
            {star <= displayRating ? '★' : '☆'}
          </span>
        ))}
      </div>
      {showLabel && displayRating > 0 && (
        <span className="star-rating-label">{getRatingLabel(displayRating)}</span>
      )}
    </div>
  );
};

export default StarRating;
